import type { DisputeStatus, DisputeType, SettlementStatus } from "../types";

export const SETTLEMENT_STATUS_LABELS: Record<SettlementStatus, string> = {
  EN_REVISION: "En revisión",
  ACEPTADA: "Aceptada",
  EN_DISPUTA: "En disputa",
  RESUELTA: "Resuelta",
  TRANSFERENCIA_PENDIENTE: "En transferencia",
  TRANSFERIDA: "Transferida",
  TRANSFERENCIA_FALLIDA: "Transferencia fallida",
};

export function settlementStatusTone(
  s: SettlementStatus,
): "neutral" | "info" | "success" | "warning" | "danger" | "accent" {
  switch (s) {
    case "EN_REVISION":
      return "warning";
    case "ACEPTADA":
      return "info";
    case "RESUELTA":
      return "accent";
    case "EN_DISPUTA":
      return "danger";
    case "TRANSFERENCIA_PENDIENTE":
      return "info";
    case "TRANSFERIDA":
      return "success";
    case "TRANSFERENCIA_FALLIDA":
      return "danger";
  }
}

export const DISPUTE_STATUS_LABELS: Record<DisputeStatus, string> = {
  abierta: "Abierta",
  en_revision_mixcore: "En revisión Mixcore",
  resuelta_a_favor_productor: "A favor productor",
  resuelta_a_favor_mixcore: "A favor Mixcore",
  resuelta_acuerdo: "Acuerdo entre partes",
};

export function disputeStatusTone(
  s: DisputeStatus,
): "neutral" | "info" | "success" | "warning" | "danger" {
  switch (s) {
    case "abierta":
      return "warning";
    case "en_revision_mixcore":
      return "info";
    case "resuelta_a_favor_productor":
    case "resuelta_a_favor_mixcore":
    case "resuelta_acuerdo":
      return "success";
  }
}

export const DISPUTE_TYPE_LABELS: Record<DisputeType, string> = {
  cantidad_tickets: "Cantidad de tickets",
  monto_total: "Monto total",
  comisiones_aplicadas: "Comisiones aplicadas",
  refund_no_reflejado: "Refund no reflejado",
  dato_personal_incorrecto: "Dato personal incorrecto",
  otro: "Otro",
};

export const SLA_COLOR_MAP: Record<"green" | "yellow" | "orange" | "red", string> = {
  green: "bg-success",
  yellow: "bg-warning/70",
  orange: "bg-warning",
  red: "bg-danger",
};

/** Formatea fecha YYYY-MM-DD a string corto. */
export function formatDateShort(iso: string | null | undefined): string {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("es-CL", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  } catch {
    return iso;
  }
}

/** Días que faltan/pasaron desde una fecha. */
export function daysFrom(iso: string | null | undefined): number | null {
  if (!iso) return null;
  try {
    const target = new Date(iso).getTime();
    const now = Date.now();
    return Math.floor((target - now) / (24 * 60 * 60 * 1000));
  } catch {
    return null;
  }
}
